"use client";
import React, { useState, useEffect } from "react";
import { usePathname } from "next/navigation";

const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const pathname = usePathname();

  // Auto scroll to top on route change
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [pathname]);

  // Show button when scrolling down
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > window.innerHeight / 2);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      title="Scroll To Top"
      className="fixed bottom-8 right-8 z-[9999] w-12 h-12 bg-[#E07A2F] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-2xl hover:bg-[#c96a28] transition-all hover:-translate-y-1"
      onClick={scrollToTop}
      style={{ display: isVisible ? "flex" : "none" }}
    >
      ↑
    </button>
  );
};

export default ScrollToTop;
